var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advantage-contain"},[_c('div',{staticClass:"advantage",style:({ backgroundImage: ("url(" + (_vm.item.img) + ")")})},[_c('div',{staticClass:"contain"},[_c('ai2',{staticClass:"ai2"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }